const employerMenu = [
	{
		id: 1,
		name: "menu.home",
		icon: "la-home",
		routePath: "/admin/dashboard",
		active: "active",
		type: "customer"
	},
	{
		id: 2,
		name: "menu.contractControl.name",
		icon: "la-user",
		active: "",
		type: "contractControl",
		children: [
			{
				id: 21,
				name: "menu.contractControl.checkLifeContract",
				routePath: "/admin/contractControl/checkLifeContract",
			},
			{
				id: 24,
				name: "menu.contractControl.checkVehicleContract",
				routePath: "/admin/contractControl/checkVehicleContract",
			},
			{
				id: 22,
				name: "menu.contractControl.lifeInsuranceContract",
				routePath: "/admin/contractControl/lifeInsurance/save",
			},
			{
				id: 23,
				name: "menu.contractControl.vehicleInsuranceContract",
				routePath: "/admin/contractControl/vehicleInsurance/save",
			}
		],
	},
	{
		id: 3,
		name: "menu.approved.name",
		icon: "la-user",
		active: "",
		type: "approved",
		children: [
			{
				id: 31,
				name: "menu.approved.commissionAgent",
				routePath: "/admin/approved/agentSpecialCommision",
			},
			{
				id: 32,
				name: "menu.approved.lifeInsurance",
				routePath: "/admin/approved/lifeInsurance",
			}
		],
	},
	{
		id: 4,
		name: "menu.notification.name",
		icon: "la la-sms",
		routePath: "/admin/notification",
		active: "",
		type: "notification"
	},
	{
		id: 5,
		name: "menu.callcenter.name",
		icon: "la-user",
		active: "",
		type: "callcenter",
		children: [
			{
				id: 51,
				name: "menu.callcenter.name",
				routePath: "/admin/callcenter/accountService",
			},
			{
				id: 52,
				name: "menu.callcenter.customer",
				routePath: "/admin/callcenter/customerService",
			},
			{
				id: 53,
				name: "menu.callcenter.agent",
				routePath: "/admin/callcenter/agentService",
			},
			{
				id: 54,
				name: "menu.callcenter.history",
				routePath: "/admin/callcenter/paymentHistory",
			}
		],
	},
	{
		id: 6,
		name: "menu.report.name",
		icon: "la-print",
		active: "",
		type: "report",
		children: [
			{
				id: 61,
				name: "menu.report.customer",
				routePath: "/admin/report/customer",
			},
			{
				id: 62,
				name: "menu.report.agent",
				routePath: "/admin/report/agent",
			},
			{
				id: 63,
				name: "menu.report.lifeInsurance",
				routePath: "",
			},
			{
				id: 64,
				name: "menu.report.vehicleInsurance",
				routePath: "",
			},
			{
				id: 65,
				name: "menu.report.nearlyExpired",
				routePath: "/admin/report/contractNearExpired",
			},
			{
				id: 66,
				name: "menu.report.agentCommision",
				routePath: "/admin/report/commissionAgent",
			},
			{
				id: 67,
				name: "menu.report.claimInsurance",
				routePath: "",
			},
			{
				id: 68,
				name: "menu.report.customerRisk",
				routePath: "/admin/report/riskVehicleContract",
			},
		],
	},
	{
		id: 7,
		name: "menu.setting.name",
		icon: "la-tools",
		active: "",
		type: "setting",
		children: [
			{
				id: 71,
				name: "menu.setting.commissionAgent",
				routePath: "/admin/setting/agentSpecialCommision",
			},
			{
				id: 72,
				name: "menu.setting.brand",
				routePath: "/admin/setting/vehicleBrand",
			},
			{
				id: 73,
				name: "menu.setting.appControl",
				routePath: "/admin/setting/appControl",
			},
			{
				id: 74,
				name: "menu.setting.roleUser",
				routePath: "/admin/setting/userPermission",
			},
			{
				id: 79,
				name: "menu.setting.webMenu",
				routePath: "/admin/setting/webMenu",
			},
			{
				id: 75,
				name: "menu.setting.agreement",
				routePath: "/admin/setting/policies",
			},
			{
				id: 66,
				name: "menu.setting.userManagement",
				routePath: "/admin/setting/users",
			},
			{
				id: 77,
				name: "menu.setting.discount",
				routePath: "/admin/setting/discounts",
			},
			{
				id: 78,
				name: "menu.setting.changePassword",
				routePath: "/admin/setting/change-password",
			},
		],
	},
	{
		id: 8,
		name: "menu.logout",
		icon: "la-sign-out",
		routePath: "/logout",
		active: "",
		type: "customer"
	},
];
export default employerMenu